window.mmajaxcart = {
  AjaxcartOpen: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),
        ajaxOverlay = $('.mm-ajaxcart-overlay');
  
    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');      
    ajaxOverlay.addClass('has--active');
  },
  AjaxcartClose: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),           	
        ajaxOverlay = $('.mm-ajaxcart-overlay');
  
    body.removeClass('mm-no-scroll');
    ajaxCart.removeClass('has--opened');      
    ajaxOverlay.removeClass('has--active');       
  },
  AjaxcartRender: function() {
    $.get('/cart?view=mm-ajax', function(cart){
      $('.mm-ajaxcart').html(cart);
            // Free Shipping Threshold Bar
      var cartPrice = parseInt($('.shipping_progress_bar').attr('data-cart-price'));
      var cartThresholdType = $('.shipping_progress_bar').attr('data-cart-threshold-type');
      var thresholdPrice = parseInt($('.shipping_progress_bar').attr('data-shipping-threshold'));
      var discount10ThresholdPrice = "";
      var discount20ThresholdPrice = "";
      var thresholdFinalPrice = thresholdPrice;
      
      if(cartThresholdType == 'shipping_with_discount10' || cartThresholdType == 'shipping_with_discount20'){
        discount10ThresholdPrice = parseInt($('.shipping_progress_bar').attr('data-discount10-threshold'));
        thresholdFinalPrice = discount10ThresholdPrice;
      }
  
      if(cartThresholdType == 'shipping_with_discount20'){
        discount20ThresholdPrice = parseInt($('.shipping_progress_bar').attr('data-discount20-threshold'));
        thresholdFinalPrice = discount20ThresholdPrice;
      }
  
      var $shippingDiff = "",
          $shippingPercentage = "",
          $shippingMessage = "";
      
      if (cartPrice < thresholdPrice){
        $shippingDiff = (thresholdPrice - cartPrice) * 100;
        $shippingPercentage = (cartPrice / thresholdPrice) * 100;
  
        $('.js-threshold-final-price').text(thresholdPrice);
        
        $('.progress_bar_cart_svg').css("left", $shippingPercentage+"%");
  
        $('#js-progress-bar').attr('value', $shippingPercentage);
        $('#js-progress-bar-msg').text(theme.beforeFreeShipping);
        
        $shippingMessage = $('#js-progress-bar-msg').text().replace('[price]', $shippingDiff/100 + ' Rs');
        
        $('#js-progress-bar-msg').text($shippingMessage);
      } 
      else if (cartPrice > thresholdPrice && cartPrice < discount10ThresholdPrice && discount10ThresholdPrice != ""){
        
        $shippingDiff = (discount10ThresholdPrice - cartPrice) * 100;
        $shippingPercentage = (cartPrice / discount10ThresholdPrice) * 100;
        
        $('.js-threshold-final-price').text(discount10ThresholdPrice);
  
        $('.progress_bar_cart_svg').css("left", $shippingPercentage+"%");
  
        $('#js-progress-bar').attr('value', $shippingPercentage);
        $('#js-progress-bar-msg').text(theme.beforeDiscount10);
        
        $shippingMessage = $('#js-progress-bar-msg').text().replace('[price]', $shippingDiff/100 + ' Rs');
        
        $('#js-progress-bar-msg').text($shippingMessage);
      
      }
      else if (cartPrice > discount10ThresholdPrice && cartPrice < discount20ThresholdPrice && discount20ThresholdPrice != ""){
        
        $shippingDiff = (discount20ThresholdPrice - cartPrice) * 100;
        $shippingPercentage = (cartPrice / discount20ThresholdPrice) * 100;
        
        $('.js-threshold-final-price').text(discount20ThresholdPrice);
  
        $('.progress_bar_cart_svg').css("left", $shippingPercentage+"%");
  
        $('#js-progress-bar').attr('value', $shippingPercentage);
        $('#js-progress-bar-msg').text(theme.beforeDiscount20);
        
        $shippingMessage = $('#js-progress-bar-msg').text().replace('[price]', $shippingDiff/100 + ' Rs');
        
        $('#js-progress-bar-msg').text($shippingMessage);
      
      }
      else{
        $('.progress_bar_cart_svg').css("left", "100%");
        $('#js-progress-bar').attr('value', '100');
        $('.js-threshold-final-price').text(thresholdFinalPrice);
        $('#js-progress-bar-msg').text(theme.afterFreeShipping);
      }
    }) 
    addFreeproductOnCartValue();
  },
  AjaxcartChangeHandler: function(data) { 
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      mmajaxcart.AjaxcartRender();
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  },
  AjaxcartQuantityHandler: function() {
    $(document).on('click', '.quantity-plus', function() { 
      console.log("Quantity plus click")
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;
      $(this).parent().find('.quantity-input').val(u).trigger('change');
    })
    $(document).on('click', '.quantity-minus', function() { 
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;
      $(this).parent().find('.quantity-input').val(u).trigger('change');
    })
    $(document).on('change', '.quantity-input', function() { 
      var UpdatedQuantity = parseInt($(this).val()),
          QuantityLine = parseInt($(this).attr('data-line')),
          params = { quantity: UpdatedQuantity, line: QuantityLine };
      
        mmajaxcart.AjaxcartChangeHandler(params);
    }) 	
  },
  AjaxcartRemoveItem: function() { 
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
      var RemoveLine = parseInt($(this).attr('data-line')),
          params = { quantity: 0, line: RemoveLine };
      
      mmajaxcart.AjaxcartChangeHandler(params);
    })
  }
  }
  
  
  $(document).ready(function() { 
  $(document).on('click', '.mm-ajaxcart-open', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartOpen();
    mmajaxcart.AjaxcartRender();
  })
  $(document).on('click', '.mm-ajaxcart-close', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
   $(document).on('click', '.mm-ajaxcart-overlay', function(e){
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
  
    mmajaxcart.AjaxcartRender();
    mmajaxcart.AjaxcartRemoveItem();
    mmajaxcart.AjaxcartQuantityHandler();
  })
  
  // Card Level Free Product Starts
  let enableFreeProduct = true
  let eligibleCartValue1 = "";
  let eligibleCartValue2 = "";
  let eligibleCartValue3 = "";
  
  if(enableFreeProduct){
    
      eligibleCartValue1 = (990)*100;
    
  
    
      eligibleCartValue2 = "";
      
  
    
      eligibleCartValue3 = "";
    
  }
  
  function addFreeproductOnCartValue(){
    if(enableFreeProduct){
       $.getJSON('/cart.js', function(res) {
        let totalCartPrice = res.total_price;
        checkFreeProductCondition(res);
        return;
      });
    }
  }
  
  function checkFreeProductCondition (cartData) { 
    let freeProduct1CartQty = 0;
    let freeProduct2CartQty = 0;
    let freeProduct3CartQty = 0;
    let totalCartPrice = cartData.items_subtotal_price;
    if(cartData.items.length > 0) {
      for(let i=0;i<cartData.items.length;i++) {
        let isFreeProductAvailable = false
        if(cartData.items[i].properties.appmaker_free_gift == "Free Gift"){
          isFreeProductAvailable = true;
          if(cartData.items[i].variant_id == freeProduct1) {
            freeProduct1CartQty = cartData.items[i].quantity;        
          }
          if(cartData.items[i].variant_id == freeProduct2) {
            freeProduct2CartQty = cartData.items[i].quantity;        
          }
          if(cartData.items[i].variant_id == freeProduct3) {
            freeProduct3CartQty = cartData.items[i].quantity;        
          }
        }
      }
    }
    
  
    if(eligibleCartValue1 !="" && totalCartPrice >= eligibleCartValue1 && freeProduct1CartQty < 1 && freeProduct1 != ""){
      addFreeProduct(1,freeProduct1)
    }
  
    if(eligibleCartValue2 !="" && totalCartPrice >= eligibleCartValue2 && freeProduct2CartQty < 1 && freeProduct2 != ""){
      addFreeProduct(1,freeProduct2)
    }
  
    if(eligibleCartValue3 !="" && totalCartPrice >= eligibleCartValue3 && freeProduct3CartQty < 1 && freeProduct3 != ""){
      addFreeProduct(1,freeProduct3)
    }
  
    // if(totalCartPrice < eligibleCartValue1 && freeProduct1CartQty >= 1 && freeProduct1 != "")
    // removefreeProduct(0,freeProduct1);
  
    // if(totalCartPrice < eligibleCartValue2 && freeProduct2CartQty >= 1 && freeProduct2 != "")
    // removefreeProduct(0,freeProduct2);
  
    // if(totalCartPrice < eligibleCartValue3 && freeProduct3CartQty >= 1 && freeProduct3 != "")
    // removefreeProduct(0,freeProduct3)
  }
  
  function addFreeProduct(qty,freeProductId){
    let formData = {
     'items': [{
      'id': freeProductId,
      'quantity': qty,
       "properties":{"appmaker_free_gift":"Free Gift"}
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      mmajaxcart.AjaxcartRender();
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
 